<template>
  <div class="main">
    <Breadcrumb :options="breadcrumb" />

    <!-- <Wxts :wxtsList="wxtsList" /> -->

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`固定费用明细表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      :getTotal="getTotal" :showTotal="true" :btns="btns" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :labelWidth="'120px'" :form="mform" :viewMode="viewMode"
      :formCtrl="mformCtrl" @onChange="onModalChange" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";
// import Wxts from '../../../components/Wxts.vue';

export default {
  mixins: [tableMixin],
  // components: { Wxts },
  data() {
    return {
      baseUrl: 'fixedpaydetail',
      getOptionUrl: 'item',
      breadcrumb: [
        { name: "财务管理", path: '/finance/fixedFeeList' },
        { name: "固定费用支出表", path: '/finance/fixedFeeList' },
        { name: "固定费用明细表" },
      ],
      wxtsList: [
        {
          name: '如需增减字段，可在【系统设置】',
          path: '/finance/fixedFee',
          pathName: '【固定费用配置】',
          tailName: '处设置。',
        },
      ],
      formInline: {},
      formCtrl: [
        {
          label: "时间选择",
          keyName: 'addtime',
          type: 'daterange',
        },
        {
          label: "费用类型",
          keyName: "fixedauth",
          type: "select",
          options: [],
        },
      ],
      cols: [
        { keyName: "month", label: "月份" },
        { keyName: "license", label: "车牌号", minwidth: 100 },
        { keyName: "driver", label: "司机姓名", minwidth: '110px' },
        { keyName: "authname", label: "费用类型", minwidth: '110px' },
        { keyName: "money", label: "费用金额", minwidth: '110px' },
        { keyName: "addtime", label: "添加日期", minwidth: '110px' },
        { keyName: "add_name", label: "填写人", minwidth: '110px' },
      ],
      getTotalProperty: ['money'],
      btns: [
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            // console.log(id)
            this.getItem(id)
            this.title = '查看固定费用'
            this.viewMode = true
            this.showDialog()
          },
        },
        {
          ...this.editBtn,
          cb: ({ id }) => {
            // console.log(id)
            this.getItem(id)
            this.title = '修改固定费用'
            this.viewMode = false
            this.showDialog()
          },
        },
      ],
      title: '查看固定费用',
      mform: {},
      mformCtrl: [
        {
          label: "车牌号",
          keyName: "license",
          type: "text",
          viewMode: true,
        },
        {
          label: "司机姓名",
          keyName: "driver",
          type: "text",
          viewMode: true,
        },
        {
          label: "费用类型",
          keyName: "fixedauth",
          type: "select",
          options: [],
        },
        {
          label: "费用金额",
          keyName: "money",
          err: "请填写费用金额",
          type: "number",
        },
        {
          label: "添加日期",
          keyName: "addtime",
          err: "请选择添加日期",
          type: "date",
        },
        {
          label: "费用凭证",
          keyName: "voucher",
          tips: "最多上传2张图片",
          type: "file",
          ptype: "fixedpay",
          max: 2,
        },
        {
          label: "备注",
          keyName: "remark",
          err: "请填写备注信息",
          type: "textarea",
          rows: 3,
        },
      ],
      baseParams: ['addtime', 'carid'],
    };
  },
  methods: {
    setOptions({ data: { fixedauth } }) {
      this.formCtrl.map(v => {
        if (v.keyName === 'fixedauth' && fixedauth && fixedauth.length) {
          this.setCtrlOption(v, fixedauth, 'authname', 'enname')
        }
      })
    },
    getItem(id) {
      const url = `fixedpaydetail/item`
      const params = { id }
      this.post(url, params, ({ msg, data }) => {
        if (msg === 'success' && data) {
          // console.log(data)
          const { detail, fixedauth } = data
          if (detail) {
            this.mform = { ...detail }
          }
          if (fixedauth && fixedauth.length) {
            this.mformCtrl.map(v => {
              if (v.keyName === 'fixedauth') {
                v.options = fixedauth.map(c => {
                  return {
                    label: c.authname,
                    value: c.enname,
                  }
                })
              }
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onModalChange({ key, value }) {
      // console.log(key, value)
      // console.log(key === 'money')
      if (['voucher'].includes(key)) {
        this.mform[key] = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
      } else {
        // this.mform[key] = value;
        this.$set(this.mform, key, value)
      }
      console.log({ ...this.mform })
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      let url = `fixedpaydetail/addedu`
      const params = {
        ...this.mform,
        userid: this.user.id,
      }
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id } = this.user
    if (user_group_id == 1) {
      this.btns.push({
        ...this.delBtn,
        cb: ({ id }) => {
          this.delete(id)
        },
      })
    } else if (user_group_id == 5) {
      this.btns.length = 1
    }
  },
  mounted() {
    this.getOptions()
    const { month, carid } = this.$route.query
    if (month) {
      this.formInline.carid = carid
      this.MONTH = this.formInline.addtime = this.getMonthRange(month)
    }
    this.$nextTick(this.getList)
  },
};
</script>

<style lang="less" scoped>
.main {
  /deep/ .dialog {
    .el-dialog {
      width: 560px;

      .modal-scroll {

        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .is-horizontal {
          display: none;
        }
      }
    }

    .btns {
      margin: 0;
      text-align: center;
    }
  }
}

/deep/ .fillet .el-form--inline .el-form-item:nth-child(2) {
  margin-right: 0px;
  padding-right: 80px;
  position: relative;

  &::after {
    position: absolute;
    content: "";
    right: 40px;
    top: 6px;
    width: 1px;
    height: 28px;
    overflow: hidden;
    background-color: #EBEDF0;
  }
}
</style>
